import { Grid } from '@chakra-ui/react'
import TabbedDisplay from 'modules/TabbedDisplay'
import EpidemiologyDashboard from './Epidemiology'
import LatestAnalysisNews from './LatestAnalysisNews'
import ModellingDashboard from './Modelling'
import Response from './Response'
import { BioriskPages } from 'config/apps/Biorisk/Custom/Biorisk/BioriskPages'
import DiseasePipeline from './Pipeline'

const BioriskMpoxTabs = () => {
  const pipelinePage = BioriskPages['BioriskMpoxPipeline']
  const approvalsPage = BioriskPages['BioriskApprovals']
  const pipelineTablePage = BioriskPages['BioriskMpoxPipelineTable']
  return (
    <TabbedDisplay
      minHeight='39px'
      tabListWrapper={(props) => (
        <Grid
          templateColumns='repeat(5, 1fr)'
          gap={2}
          width='100%'
          {...props}
        />
      )}
      tabs={[
        {
          heading: 'Latest Analysis & News',
          body: <LatestAnalysisNews />,
        },
        {
          heading: 'Epidemiology',
          body: <EpidemiologyDashboard />,
        },
        {
          heading: 'Response',
          body: <Response />,
        },
        {
          heading: 'Competitive Landscape',
          body: (
            <DiseasePipeline
              disease='Mpox'
              pages={{ pipelinePage, approvalsPage, pipelineTablePage }}
            />
          ),
        },
        {
          heading: 'Forecasting',
          body: <ModellingDashboard />,
        },
      ]}
    />
  )
}

export default BioriskMpoxTabs
